function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m35.768 27.114c2.02 0 3.879-1.301 3.879-3.348 0-2.07-1.566-3.48-3.875-3.48h-1.32c-3.106 0-5.649 2.379-5.649 5.813v7.356h-5.292v-7.336c0-4.102 4.187-7.34 9.234-7.34h3.699c3.801 0 8.402 1.238 8.402 4.988 0 3.825-4.215 4.989-8.406 4.989h-7.012v-1.641h6.34z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m48.745 18.777h5.293v14.676h-5.293z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m72.897 26.86h-9.148c.367 2.785 2.559 4.867 5.133 4.867h6.867v1.664h-8.355c-5.047 0-9.238-3.238-9.238-7.336 0-4.102 4.188-7.34 9.234-7.34h8.359v1.629h-6.867c-2.586 0-4.781 2.102-5.137 4.902h9.152z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m6.835 22.07c0 .59.703 1.121 1.961 1.465 1.265.344 2.855.742 4.484 1.137 3.223.781 6.613 1.821 6.613 4.235 0 2.707-4.875 4.547-11.492 4.547-2.426 0-4.734-.238-7.078-.906l.746-1.316c2.133.781 5.168.93 7.406.93 2.715 0 4.918-.863 4.918-2.125 0-.723-.718-1.332-1.922-1.652-1.226-.324-2.796-.727-4.394-1.086-3.156-.707-6.488-1.641-6.488-4.176 0-2.438 3.527-4.344 10.035-4.344 2.051 0 5.039.266 6.953 1.027l-.844 1.055c-1.98-.563-4.23-.773-6.281-.773-3.431-.002-4.617.959-4.617 1.982"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m44.112 8.434c0-4.019 3.258-7.277 7.281-7.277 3.297 0 6.082 2.191 6.977 5.199-.57-.848-1.234-1.625-1.984-2.316-.148.062-.297.125-.441.187.977.762 1.84 1.66 2.563 2.664.086.391.137.793.156 1.207-.953-1.363-2.258-2.582-3.633-3.441-.203.101-.41.211-.617.328 1.605.805 3.137 2.043 4.258 3.488 0 .317-.023.625-.063.931-1.391-1.716-3.223-3.017-5.297-3.767-.262.168-.527.348-.789.539 2.323.571 4.421 1.824 6.026 3.598-.051.272-.117.543-.199.809-1.844-1.879-4.313-3.137-7.07-3.418-.309.269-.606.546-.891.835h.117c2.848-.003 5.598 1.059 7.711 2.973-.098.263-.211.517-.336.763-1.969-1.599-4.426-2.47-6.961-2.466-.598 0-1.184.048-1.758.142-.285.367-.559.757-.816 1.168.973-.274 1.98-.411 2.992-.411 2.258-.003 4.461.692 6.313 1.989-.156.258-.328.511-.516.75-1.629-.965-3.488-1.474-5.383-1.47-1.559 0-3.043.337-4.375.945-.211.461-.395.93-.559 1.41 1.621-.957 3.469-1.46 5.352-1.457 1.637 0 3.184.372 4.566 1.039-1.375 1.493-3.316 2.344-5.348 2.34-4.018 0-7.276-3.257-7.276-7.281"
});

var SvgSpie = function SvgSpie(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    enableBackground: "new 0 0 77.285 34.812",
    viewBox: "0 0 77.285 34.812",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSpie, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "spie.svg";
export { ForwardRef as ReactComponent };